export default class RemoveFromCartTrackingDataBuilder{
    build(product){
        return {
            currencyCode: window.gtmeecom.currencyCode || '',
            remove: {
                actionField: {
                    list: "Shopping Cart"
                },
                products: [product]
            }
        }
    }
}